import { render, staticRenderFns } from "./entradaDetalhes.vue?vue&type=template&id=01025168&scoped=true&"
import script from "./entradaDetalhes.vue?vue&type=script&lang=js&"
export * from "./entradaDetalhes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01025168",
  null
  
)

export default component.exports